import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DEFAULT_LANGUAGE } from './language.const';
import { LocalStorageService } from '../storage/local-storage.service';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly languageStorageKey = 'lang';

  private readonly currentLanguage$: BehaviorSubject<string> =
    new BehaviorSubject(DEFAULT_LANGUAGE);

  private readonly localStorageService = inject(LocalStorageService);
  private readonly translateService = inject(TranslateService);

  public initCurrentLanguage(): void {
    const currentLanguage =
      this.localStorageService.get(this.languageStorageKey) || DEFAULT_LANGUAGE;

    if (currentLanguage !== DEFAULT_LANGUAGE) {
      this.setCurrentLanguage(currentLanguage);
    }

    this.currentLanguage$.subscribe((language: string) => {
      this.localStorageService.set(this.languageStorageKey, language);
      this.translateService.use(language);
    });
  }

  public getCurentLanguage(): string {
    return this.currentLanguage$.value;
  }

  public getCurentLanguageObservable(): Observable<string> {
    return this.currentLanguage$.asObservable();
  }

  public setCurrentLanguage(name: string): void {
    this.currentLanguage$.next(name);
  }
}
